// @ts-nocheck
export class CpuRegister {
    name;
    code;
    offset;
    dataView;
    constructor(name, offset, dataView, code) {
        this.name = name;
        this.offset = offset;
        this.dataView = dataView;
        this.code = code;
    }
    get value() {
        return this.dataView.getUint8(this.offset);
    }
    set value(newValue) {
        this.dataView.setUint8(this.offset, newValue);
    }
}
export class DoubleCpuRegister extends CpuRegister {
    get value() {
        return this.dataView.getUint16(this.offset, true);
    }
    set value(newValue) {
        this.dataView.setUint16(this.offset, newValue, true);
    }
}
//# sourceMappingURL=cpu-register.js.map